<template>
  <div class="auth-wrapper">
    <div class="auth-container">
      <div class="auth-grid">
        <!-- Side Image Section (7/12 width on desktop) -->
        <div class="auth-side-section">
          <img 
            src="../assets/img-auth-sideimg.png" 
            alt="Authimg" 
            class="auth-side-image"
          />
        </div>
        
        <!-- Form Section (5/12 width on desktop) -->
        <div class="auth-form-section">
          <div class="auth-form-container">
            <!-- Logo Section -->
            <div class="logo-main">
              <img src="../assets/appcharge-logo.png" alt="icon logo" class="main-logo" />
              <p class="app-subtitle">Vue SDK Test Store</p>
            </div>
            
            <!-- Login Button Section -->
            <div class="login-section">
              <button 
                class="google-login-button" 
                @click="handleGoogleLogin" 
                :disabled="isLoading"
              >
                <svg class="google-logo" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-0.5 0 48 48">
                  <path d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24" fill="#FBBC05"></path>
                  <path d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333" fill="#EB4335"></path>
                  <path d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4455,47.4666667 34.9177955,45.4314667 39.0249545,41.6181333 L31.5177727,35.8144 C29.3995682,37.1488 26.7323182,37.8666667 23.7136364,37.8666667" fill="#34A853"></path>
                  <path d="M46.1454545,24 C46.1454545,22.6133333 45.9318182,21.12 45.6113636,19.7333333 L23.7136364,19.7333333 L23.7136364,28.8 L36.3181818,28.8 C35.6879545,31.8912 33.9724545,34.2677333 31.5177727,35.8144 L39.0249545,41.6181333 C43.3393409,37.6138667 46.1454545,31.6490667 46.1454545,24" fill="#4285F4"></path>
                </svg>
                <span>{{ isLoading ? 'Signing in...' : 'Continue with Google' }}</span>
              </button>
              
              <!-- Auth Divider -->
              <div class="auth-divider-container">
                <div class="auth-divider">
                  <span class="divider-text">Don't have an account?</span>
                </div>
                <p class="signup-text">
                  Send a Slack message to 
                  <a href="mailto:shai@appcharge.com" class="contact-link">Shai</a> 
                  to create one.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      isLoading: false,
      googleClientId: '178320554692-4g4o876ev6fcd5j5u9ob7k5g0d8170hq.apps.googleusercontent.com',
      googleClient: null
    }
  },
  mounted() {
    this.initGoogleOAuth()
  },
  methods: {
    async initGoogleOAuth() {
      try {
        // Wait for Google Identity Services to load
        await this.waitForGoogleGSI()
        
        // Initialize the OAuth2 client for getting access tokens
        this.googleClient = window.google.accounts.oauth2.initTokenClient({
          client_id: this.googleClientId,
          scope: 'profile email',
          callback: this.handleGoogleCallback,
        })
        
        console.log('Google OAuth2 initialized successfully')
      } catch (error) {
        console.error('Failed to initialize Google OAuth:', error)
        this.showError('Failed to initialize Google authentication')
      }
    },
    
    waitForGoogleGSI() {
      return new Promise((resolve, reject) => {
        const checkGoogle = () => {
          if (window.google && window.google.accounts && window.google.accounts.oauth2) {
            resolve()
          } else {
            setTimeout(checkGoogle, 100)
          }
        }
        checkGoogle()
        
        // Timeout after 10 seconds
        setTimeout(() => reject(new Error('Google GSI failed to load')), 10000)
      })
    },
    
    async handleGoogleLogin() {
      if (!this.googleClient) {
        this.showError('Google authentication not initialized')
        return
      }
      
      this.isLoading = true
      
      try {
        // Request access token using the new Google Identity Services
        this.googleClient.requestAccessToken()
      } catch (error) {
        console.error('Login error:', error)
        this.showError('Login failed. Please try again.')
        this.isLoading = false
      }
    },
    
    async handleGoogleCallback(response) {
      try {
        console.log('Google OAuth response:', response)
        
        if (response.error) {
          throw new Error(response.error)
        }

        // Successful login
        localStorage.setItem('__ac_user', response.access_token)      
        this.$router.push('/home')
        
      } catch (error) {
        console.error('Login callback error:', error)
        this.showError('Login failed. Please try again.')
      } finally {
        this.isLoading = false
      }
    },
    
    showError(message) {
      this.$toasted.error(message, {
        duration: 5000,
        position: 'top-center'
      })
    }
  }
}
</script>

<style scoped>
/* AuthWrapper equivalent */
.auth-wrapper {
  min-height: 100vh;
}

.auth-container {
  min-height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Grid Layout */
.auth-grid {
  min-height: calc(100vh - 112px);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Side Image Section (7/12 width) */
.auth-side-section {
  flex: 0 0 58.333333%; /* 7/12 = 58.333% */
  display: none;
  align-self: center;
  justify-content: flex-start;
}

@media (min-width: 960px) {
  .auth-side-section {
    display: flex;
  }
}

.auth-side-image {
  height: 100vh;
  min-height: 100%;
  width: 100%;
  object-fit: cover;
}

/* Form Section (5/12 width) */
.auth-form-section {
  flex: 0 0 41.666667%; /* 5/12 = 41.666% */
  display: flex;
  justify-content: center;
  padding: 56px;
}

@media (max-width: 959px) {
  .auth-form-section {
    flex: 1;
  }
}

.auth-form-container {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 24px; /* spacing={3} in Material-UI */
}

/* Logo Section */
.logo-main {
  text-align: center;
  margin-top: 16px; /* mt={2} equivalent */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.main-logo {
  width: 150px;
  height: auto;
}

.app-subtitle {
  font-size: 12px;
  color: gray;
  margin-top: 4px; /* mt={0.5} equivalent */
  margin-bottom: 0;
  font-weight: 600;
}

/* Login Section */
.login-section {
  margin-top: -16px; /* mt={-2} equivalent */
}

/* Google Login Button - matching React App.scss exactly */
.google-login-button {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  padding: 0.5rem 1.5rem; /* Exact padding from React */
  font-size: 0.875rem;
  font-weight: 500;
  color: #1f2937;
  width: 100%;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.google-login-button:hover {
  background-color: #f9fafb;
}

.google-login-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.5);
}

.google-login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.google-logo {
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 0.5rem;
}

/* Auth Divider Container */
.auth-divider-container {
  margin-top: 16px; /* mt={2} */
}

/* Auth Divider - matching React AuthDivider component */
.auth-divider {
  position: relative;
  display: flex;
  margin-bottom: 16px;
}

.auth-divider::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  z-index: 1;
  background: #e0e0e0; /* Material-UI divider color */
}

.divider-text {
  background: white;
  position: relative;
  padding: 8px 20px;
  margin: 0 auto;
  z-index: 5;
  color: #666;
  font-size: 1rem;
  font-weight: 400;
}

/* Signup Text */
.signup-text {
  text-align: center;
  font-size: 0.875rem;
  color: #666;
  margin: 0;
  line-height: 1.43;
}

.contact-link {
  text-decoration: underline;
  color: purple; /* Matching React inline style */
}

.contact-link:hover {
  color: #6a1b9a;
}
</style> 